/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, formValueSelector, reduxForm, reset } from 'redux-form';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import { renderAutoCompleteScheduling, renderAutoCompleteSingleSelect, renderCheckBox, renderDateField } from '../components/reduxFields';
import { getOrganizationFinancialKPIGraph } from '../modules/Dashboards/actions/StaffDashboardActions';
import moment from 'moment';
import Slider from 'react-rangeslider'
import { currencyFormat } from '../actions/utilAction';
import {getTrendLine, getTrendData, getAverageLine} from '../chartUtils/utlis';

Exporting(Highcharts);
ExportingData(Highcharts);
/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class FinancialKPI_AMOUNTBILLED extends Component {

  constructor(props) {
    super(props);        
    this.state = {        
      sliderMaxValue: 100,
        sliderValue: 100,        
        xAxisDateOption: [],  
        isReset: false
      };    
  }

  // loadOrganizationBillableHoursGraph() {
  //   let searchObj3 = {
  //     contain_filters: {
  //       fromDate: this.state.FromFinancialDate ? moment(this.state.FromFinancialDate).format('YYYY-MM-DD') : new Date(),
  //       toDate: this.state.ToFinancialDate ? moment(this.state.ToFinancialDate).format('YYYY-MM-DD') : new Date(),
  //       payerIds: [],
  //       appointmentTypeIds: [],
  //       staffIds: [],
  //       patientIds: [],
  //       locationIds: [],
  //       //IsBillable: isBillable ? true : false, 
  //     }, 
  //   };
  //   this.props.getOrganizationFinancialKPIGraph(searchObj3);
  // }

  componentDidMount = () => {
    this.highchartsHandler();
  }

  componentDidUpdate = () => {
      if(this.props.financialDataAnalytics !== null) {
          this.highchartsHandler();
      }
  }

  handleReset = () => {
    this.props.dispatch(reset('FinancialKPI_AMOUNTBILLEDForm'));    
    this.props.handleResetFinancialKPI();
  };

  // currencyFormat = (num) => {
  //   return '$' + num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  // }

  highchartsHandler = () => {
    let finalData = [];
    let recordId = [];
    let xAxisDateBeforeSorting = [];
    let xAxisDate = [];    
    let xAxisLabel = 'Billed Amount(s)';    
    let yAxisLabel = 'Date';    
    let disableLegend = this.props.disableLegend;
    let gridlinesWidth = this.props.hideGridlines ? 0 : 1;
    
    let  avgPlotLine = {}; //seriesSum = 0, seriesCount = 0,
    let plotLines = [];
    let totalPayment = 0;    
    let totalPaymentToDisplay ='';    
    if (this.props.financialDataAnalytics !== null && this.props.financialDataAnalytics.data != null && this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph != null  && this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph.length > 0) {
      this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph.map((obj, index) => {

        if(obj.reportType === 'ByMonth')
        {
            let dataObj = {}
            let paymentAmount = [];
            let organizationFinancialKPIGraph = this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph;
            for (let i = 0; i < organizationFinancialKPIGraph.length; i++) {
                if(xAxisDateBeforeSorting.indexOf(moment(organizationFinancialKPIGraph[i].dos).format('MMM/yyyy')) === -1)
                {
                    xAxisDateBeforeSorting.push(moment(organizationFinancialKPIGraph[i].dos).format('MMM/yyyy'));
                }
            }

            xAxisDateBeforeSorting.sort((dateA, dateB) => new Date(dateA) - new Date(dateB));

            for(let j = 0; j < xAxisDateBeforeSorting.length; j++)
            {  
                xAxisDate[j] = moment(xAxisDateBeforeSorting[j]).format('MMM/yyyy');
            }
             if(recordId.indexOf(obj.recordId) === -1)
             {
                let organizationFinancialKPIGraphData = this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph.filter((op) => op.recordId === obj.recordId);
                paymentAmount = [];
                for (let i = 0; i < organizationFinancialKPIGraphData.length; i++) {
                    dataObj['name'] = organizationFinancialKPIGraphData[i].title;
                    dataObj['recordId'] = organizationFinancialKPIGraphData[i].recordId;
                    recordId.push(organizationFinancialKPIGraphData[i].recordId);
                    if(xAxisDate.indexOf(moment(organizationFinancialKPIGraphData[i].dos).format('MMM/yyyy')) > -1)
                    {
                        let index = xAxisDate.indexOf(moment(organizationFinancialKPIGraphData[i].dos).format('MMM/yyyy'));
                        paymentAmount[index] = parseFloat(organizationFinancialKPIGraphData[i].y);
                        totalPayment = totalPayment + parseFloat(organizationFinancialKPIGraphData[i].y);
                        // paymentAmount.push(organizationFinancialKPIGraphData[i].y);
                        // seriesSum += parseFloat(organizationFinancialKPIGraphData[i].y);
                        // seriesCount += 1;
                       // console.log('totalPayment..........',totalPayment)
                    }
                }
                totalPaymentToDisplay = currencyFormat(totalPayment.toFixed(2).toString())

                for(let j = 0; j < xAxisDate.length; j++)
                {
                    //if(!paymentAmount[j])
                    if(paymentAmount[j] === undefined || paymentAmount[j] < 0)
                    {
                      paymentAmount[j] = null;
                    }
                }
                
                if (this.state.sliderMaxValue !== Math.max(...paymentAmount)) {                    
                    this.setState({sliderMaxValue: Math.max( ...paymentAmount), sliderValue: Math.max( ...paymentAmount)});                        
                }
                dataObj['data'] = paymentAmount;                
                finalData.push(dataObj);
            }
          }
          else
          {
            let dataObj = {}
            let paymentAmount = [];
            let organizationFinancialKPIGraph = this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph;
            for (let i = 0; i < organizationFinancialKPIGraph.length; i++) {
                if(xAxisDateBeforeSorting.indexOf(moment(organizationFinancialKPIGraph[i].dos).format('MM/DD/YYYY')) === -1)
                {
                    xAxisDateBeforeSorting.push(moment(organizationFinancialKPIGraph[i].dos).format('MM/DD/YYYY'));
                }
            }

            xAxisDateBeforeSorting.sort((dateA, dateB) => new Date(dateA) - new Date(dateB));

            for(let j = 0; j < xAxisDateBeforeSorting.length; j++)
            {  
                xAxisDate[j] = moment(xAxisDateBeforeSorting[j]).format('MM/DD/YYYY');
            }
             if(recordId.indexOf(obj.recordId) === -1)
             {
                let organizationFinancialKPIGraphData = this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph.filter((op) => op.recordId === obj.recordId);
                paymentAmount = [];
                for (let i = 0; i < organizationFinancialKPIGraphData.length; i++) {
                    dataObj['name'] = organizationFinancialKPIGraphData[i].title;
                    dataObj['recordId'] = organizationFinancialKPIGraphData[i].recordId;
                    recordId.push(organizationFinancialKPIGraphData[i].recordId);
                    if(xAxisDate.indexOf(moment(organizationFinancialKPIGraphData[i].dos).format('MM/DD/YYYY')) > -1)
                    {
                        let index = xAxisDate.indexOf(moment(organizationFinancialKPIGraphData[i].dos).format('MM/DD/YYYY'));
                        paymentAmount[index] = parseFloat(organizationFinancialKPIGraphData[i].y);
                        totalPayment = totalPayment + parseFloat(organizationFinancialKPIGraphData[i].y);
                        // paymentAmount.push(organizationFinancialKPIGraphData[i].y);
                        // seriesSum += parseFloat(organizationFinancialKPIGraphData[i].y);
                        // seriesCount += 1;
                       // console.log('totalPayment..........',totalPayment)
                    }
                }
                totalPaymentToDisplay = currencyFormat(totalPayment.toFixed(2).toString())

                for(let j = 0; j < xAxisDate.length; j++)
                {
                    //if(!paymentAmount[j])
                    if(paymentAmount[j] === undefined || paymentAmount[j] < 0)
                    {
                      paymentAmount[j] = null;
                    }
                }
                
                if (this.state.sliderMaxValue !== Math.max(...paymentAmount)) {                    
                    this.setState({sliderMaxValue: Math.max( ...paymentAmount), sliderValue: Math.max( ...paymentAmount)});                        
                }
                dataObj['data'] = paymentAmount;                
                finalData.push(dataObj);
            }
          }

        });

    }

    if(xAxisDate.length && this.state.xAxisDateOption.length != xAxisDate.length)
      {
          let xAxisDate1 = [];

          xAxisDate1 = xAxisDate.map((d,i)=>{
              return {
                  'id':i,
                  'value':d.toString()
              }
          })

          this.setState({xAxisDateOption: xAxisDate1}
              ,()=>{ this.setState({})}
              );           
      }

    finalData.reverse();

    function formatSecondsToDate(seconds) {
      const date = new Date(new Date(seconds).toUTCString());
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1;
      let year = date.getUTCFullYear();

      let formattedMonth = month < 10 ? `0${month}` : `${month}`;
      let formattedDay = day < 10 ? `0${day}` : `${day}`;

      let formattedDate = `${formattedMonth}/${formattedDay}/${year}`;
      return formattedDate;
    }

    function modifyMulArrToSingleWithYAxis(arr,length,type){
      let updatedArr = [];
      if(type=="trendline" && arr.length){
        let emptyArry = new Array(length).fill(null);
        emptyArry[0] = parseFloat(arr[0][1].toFixed(2));
        emptyArry[length-1] = parseFloat(arr[1][1].toFixed(2));
        updatedArr = emptyArry;
      }else if(arr.length){
        for(let i=0;i<length;i++){
          if(arr[i] && arr[i][1] != null && arr[i][1] != undefined){
            updatedArr.push(parseFloat(arr[i][1].toFixed(2)))
          }else {
            updatedArr.push(null);
          }
        }
      }
      return updatedArr;
    }
    let chartData = [];
    let trendData = [];
    let averageLine = [];
    let singleAvg =[];
    let trendLine = [];
    let lineChartTooltipName = "Billed Amount ($)"
    let isFinalChart = false;
    let isOtherLineChart = false;
    if(this.props.financialDataAnalytics !== null && this.props.financialDataAnalytics.data != null && this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph != null && this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph.length > 0) {
        let graphHoursData = this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph;
        trendData = getTrendData(graphHoursData, "y","dos");
        averageLine = getAverageLine(trendData);
        singleAvg = averageLine[0][1];
        plotLines = []
        // console.log("trendData",trendData);
        // console.log("averageLine",averageLine);
        trendLine = getTrendLine(trendData);
        let avgD = {};
          if(averageLine){    
              let length = averageLine.length;
              let newArray = new Array(length);
              let sAvg = parseFloat(singleAvg)
              let filledArray = newArray.fill(null);
              filledArray[0] = sAvg;
              filledArray[newArray.length-1] = sAvg;
              avgD = filledArray;
              averageLine = avgD;
        }
      }
  



    if(this.props.showTrendChart && !this.props.showDisplayAverage){
      isFinalChart = false;
      isOtherLineChart = true;
      chartData = [];
      chartData.push(
          {
            // type: 'scatter',
            type: 'line',
            name: lineChartTooltipName,
            data: modifyMulArrToSingleWithYAxis(trendData,trendData.length), 
            marker: {
                radius: 4
            }
        },
        {
        
          type: 'line',
          name: 'Trend Line',
          data: modifyMulArrToSingleWithYAxis(trendLine,trendData.length,"trendline"),
          value: 454,
          width: 2,
          marker: {
              enabled: false
          },
          dashStyle: 'longdash',
          color:"#000000"
        }
      );
      xAxisDate = trendData.map(([a,b])=>formatSecondsToDate(a)); 
    }else if(this.props.showDisplayAverage && !this.props.showTrendChart){
      isOtherLineChart = true;
      isFinalChart = false;
      chartData = [];
      plotLines.push({
        color:"#000000",
        width: 2,
        value: [singleAvg],
        zIndex: 4,
        dashStyle: 'Dash',
        label: {
          text: singleAvg && singleAvg != 0 ? `${singleAvg} Avg`:'',
          align: 'right',
          x: 0,
          y: -10
      }
    });   
      chartData.push(
          {
            // type: 'scatter',
            type: 'line',
            name: lineChartTooltipName,
            data: modifyMulArrToSingleWithYAxis(trendData,trendData.length),  
            marker: {
                radius: 4
            }
        },
        {
          type: 'line',
          name: 'Average Line',
          data: averageLine,
          width: 2,
          marker: {
            enabled: false
          },
          color: 'transparent',
          dashStyle: 'shortdash',
        }
      );
      xAxisDate = trendData.map(([a,b])=>formatSecondsToDate(a));
    }else if(this.props.showTrendChart && this.props.showDisplayAverage){
      isOtherLineChart = true;
      isFinalChart = false;
      chartData = [];
      plotLines.push({
        color:"#000000",
        width: 2,
        value: [singleAvg],
        zIndex: 4,
        dashStyle: 'Dash',
        label: {
          text: singleAvg && singleAvg != 0 ? `${singleAvg} Avg`:'',
          align: 'right',
          x: 0,
          y: -10
      }
    });   
      chartData.push(
        {
          // type: 'scatter',
          type: 'line',
          name: lineChartTooltipName,
          data: modifyMulArrToSingleWithYAxis(trendData,trendData.length),  
          marker: {
              radius: 4
          }
      },
      {
      
        type: 'line',
        name: 'Trend Line',
        data: modifyMulArrToSingleWithYAxis(trendLine,trendData.length,"trendline"),
        width: 2,
        marker: {
            enabled: false
        },
        dashStyle: 'longdash',
        color:"#000000"
      },{
        type: 'line',
        name: 'Average Line',
        data: averageLine,
        width: 2,
        marker: {
          enabled: false
        },
        color: 'transparent',
        dashStyle: 'shortdash',
      }
    );
    xAxisDate = trendData.map(([a,b])=>formatSecondsToDate(a)); 
    }else{
      isOtherLineChart = false;
      isFinalChart = true;
      chartData = finalData;
    }




    Highcharts.setOptions({
        lang: {
            thousandsSep: ','
          },
        colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
    });

    Highcharts.chart('analyticsDataDivBilledAmount', {
        title: {
            text: 'Total Billed Amount(s): ' + totalPaymentToDisplay
        },
        //annotations: this.state.AnnotationLabel,
        yAxis: {
            gridLineWidth: gridlinesWidth,
            minorGridLineWidth: gridlinesWidth,
            title: {
            text: `<b>${xAxisLabel}</b>`
            },
            labels: {
                enabled: true
            },
            min: 0,
            max: this.state.sliderValue,
            plotLines: plotLines
        },
        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            enabled: disableLegend,
        },

        xAxis: {
            // type: isOtherLineChart && 'datetime',
            title: {
                text: `<b>${yAxisLabel}</b>`,
            },
            tickLength: 0,
            categories: xAxisDate,
            labels: {
              // rotation: isOtherLineChart && -45,
              // formatter: isOtherLineChart && function() {
              //   return Highcharts.dateFormat('%m/%d/%Y', this.value);
              // },
              enabled: true
            },
            //plotLines: this.state.BaselineLabel,
        },

        credits: {
            enabled: false
        },

        plotOptions: {
            series: {
                cursor: 'pointer',
                connectNulls:true,
                //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                fillOpacity: 0.6,
                label: {
                    connectorAllowed: false
                },
                dataLabels: {
                    enabled: false
                },
                events: {
                    legendItemClick: function () {
                        return false
                    }
                },
                marker: {
                    enabled: true        
                }
            }
        },

        series: chartData,

        // series: [{
        //     name: 'Installation',
        //     data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
        // }, {
        //     name: 'Manufacturing',
        //     data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
        // }],

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        enabled: disableLegend,
                    }
                }
            }]
        },

        navigation: {
            buttonOptions: {
                verticalAlign: 'top',
                x: -100
            }
        },

        lang: {
            contextButtonTitle: 'Click to open'
        },

        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                }
            },
            chartOptions: {
                colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
            }
        }
    });
}

onSliderChange = (value) => {     
  this.setState({
      sliderValue: value
  },()=> this.highchartsHandler());
}

  render() {    
    let { sliderValue } = this.state
    //const { handleSubmit, OrganizationAuthorization } = this.props;
   // const authList =  (OrganizationAuthorization && OrganizationAuthorization.data) || []
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
                <form className="readmin-form custom_form" >                
                  <div className="row end-flex">         
                    <div className="col-sm-3 ml-10">
                      <Field name="FromFinancialDate"
                        placeholder="From Date"
                        locale="en-US"
                        selected={this.props.FromFinancialDate}
                        onDateChange={this.props.onFinancialKPIDateChange}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>
                    <div className="col-sm-3 ml-10">
                      <Field name="ToFinancialDate"
                        placeholder="To Date"
                        locale="en-US"
                        minDate = {this.props.FromFinancialDate}
                        selected={this.props.ToFinancialDate}
                        openToYearSelection={true}
                        onDateChange={this.props.onFinancialKPIDateChange}
                        component={renderDateField} />
                    </div>                 
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field name="financialPayerIds"
                        label="Payer"
                        handleNewRequest={this.props.handleFinancialChange}
                        options={this.props.masterInsuranceCompanies}
                        component={renderAutoCompleteScheduling}
                      />
                    </div>                                                
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field
                        name="financialPatientIds"
                        label="Client"
                        handleNewRequest={this.props.handleFinancialChange}
                        options={this.props.patientlist}
                        component={renderAutoCompleteScheduling}
                        fullWidth={true}
                      />
                    </div>  
                    </div>   
                    <div className="row end-flex">                      
                      <div className="col-sm-3 mt-30">
                          <Field
                            name="byWeekOrMonth"
                            label="By Week Or Month"                          
                            handleNewRequest={this.props.handleFinancialReportTypeChange}
                            options={this.props.ByWeekOrMonthList}
                            component={renderAutoCompleteSingleSelect}                          
                          />
                      </div>      
                      <div className="col-sm-3 mt-30">
                        <Field
                          name="displayByAllowedAmount"
                          label="Display By Allowed Amount"
                          onChange={(e) => this.props.checkFinancialDisplayByAllowedAmount(e)}
                          component={renderCheckBox}
                        />
                      </div>
                      <div className="col-sm-3 mt-30">
                        <Field
                          name="searchBySubmittedDates"
                          label="Search By Submitted Date"
                          onChange={(e) => this.props.checkFinancialSearchBySubmittedDates(e)}
                          component={renderCheckBox}
                        />
                      </div>
                      <div className="col-sm-3 mt-30">
                        <Field
                          name="ShowDisplayAverage"
                          label="Display Average"
                          component={renderCheckBox}
                        />
                      </div>                  
                    </div>
                    <div className='row end-flex'>
                    <div className='col-sm-3 mt-35'>
                      <Field
                        name="ShowTrendChart"
                        label="Display Trendlines"
                        component={renderCheckBox}
                      />
                    </div>
                    <div className='col-sm-3 mt-35'>
                      <Field
                        name="financialLocationIds"
                        label="Location"
                        handleNewRequest={this.props.handleFinancialChange}
                        options={this.props.userLocationList}
                        component={renderAutoCompleteScheduling}
                        fullWidth={true}
                      />
                    </div>
                    <div className="col-sm-3 ml-10 mt-35"></div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                    </div>
                  </div>
              </form>    
          </div>
        </div>
        <div className='row'>            
          <div className='col-sm-auto'>
                <Slider 
                    min={0}
                    max={this.state.sliderMaxValue}                           
                    value={sliderValue}
                    orientation="vertical"
                    onChange={(e)=>this.onSliderChange(e)}
                    tooltip={false}
                />
            </div>
            <div className='col-sm-11'>
              {
                  this.props.loading ? "Loading..." :
                  <div>                         
                      {this.state.xAxisDateOption.length > 0 ? 
                      <div className='row'>                          
                          <div className='col-sm-6'></div>
                      </div>   
                      : null}
                      <div id='analyticsDataDivBilledAmount' style={{ height: '500px' }} /> 
                  </div>
              }
            </div>
          </div>        
      </div>
    );
  }
}

const initialValues = {
  ShowTrendChart:false,
  ShowDisplayAverage:false,
}


FinancialKPI_AMOUNTBILLED = reduxForm({
  form: 'FinancialKPI_AMOUNTBILLEDForm',
  initialValues
})(FinancialKPI_AMOUNTBILLED);

const selector = formValueSelector('FinancialKPI_AMOUNTBILLEDForm');

function mapStateToProps(state) {   
    //console.log('state.staff_dashboard2............',state.staff_dashboard)
    let showTrendChart = selector(state,'ShowTrendChart');
    let showDisplayAverage = selector(state,'ShowDisplayAverage');

  return {
    showTrendChart,
    showDisplayAverage,
    financialDataAnalytics: state.staff_dashboard ? state.staff_dashboard.OrganizationFinancialKPIGraph : {},    
    RightPanel_loading: state.staff_dashboard.RightPanel_loading,
  };
}

export default connect(mapStateToProps, { getOrganizationFinancialKPIGraph })(FinancialKPI_AMOUNTBILLED);



// WEBPACK FOOTER //
// ./src/adminCharts/FinancialKPI_AMOUNTBILLED.js